import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useHistory } from 'react-router';

import type { Goal } from '@feathr/blackbox';
import { useLocalUrl } from '@feathr/extender/state';

import { GoalOptionsMenu } from '../../GoalActions';

interface IGoalDetailOptionsProps {
  goal: Goal;
  // Edit opens a page-level drawer, so the handler is lifted to the page.
  onEdit: () => void;
}

function GoalDetailOptions({ goal, onEdit }: Readonly<IGoalDetailOptionsProps>): JSX.Element {
  const history = useHistory();
  const localUrl = useLocalUrl();

  function handleDeleteSuccess(): void {
    history.push(localUrl('/reports/conversions/goal-manager'));
  }

  return (
    <GoalOptionsMenu
      buttonType={'icon-outlined'}
      goal={goal}
      onDeleteSuccess={handleDeleteSuccess}
      onEdit={onEdit}
    />
  );
}

export default observer(GoalDetailOptions);
